import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import '@/assets/styles/global.css'
import '@/assets/styles/mobile-dialog-fix.css'

Vue.use(ElementUI)
Vue.use(mavonEditor)

// 使用封装的 request 实例
Vue.prototype.$http = request

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 